import MaterialTable from 'material-table';
import React, { useEffect, useState, useMemo } from 'react';
import { styledTableHeading } from '../../../helpers';
import { localization, modifyDefaultOptions, tableIconsModified } from '../../../helpers/table';
import useAPI from '../../../hooks/useAPI';
import { useAPIAgreementKpsCodes } from '../../../pages/admin/adminApiService';
import EditSelectYear from '../../table/EditSelectYear';

export default function AgreementKpsCodes({ agreementId, title }) {
  const api = useAPI();
  const [getKpsCodesByAgreementId, saveKpsCode, removeKpsCode] = useMemo(() => useAPIAgreementKpsCodes(api), [api]);

  const [data, setData] = useState([]);

  useEffect(async () => {
    const resp = await getKpsCodesByAgreementId(agreementId);
    if (resp && !resp.error) { setData(resp); }
  }, [agreementId]);

  const columns = [
    {
      title: 'Год',
      field: 'year',
      editComponent: (_props) => (
        <EditSelectYear value={_props.value} onChange={_props.onChange} />),
    },
    { title: 'Аналитический код КПС', field: 'kpsCode' },
    { title: 'Код полный', field: 'fullCode' },
  ];

  return (
    <MaterialTable
      title={(
        <h3 style={styledTableHeading}>
          Субсидии по годам Соглашения
          {title}
        </h3>
)}
      options={modifyDefaultOptions({
        actionsColumnIndex: -1,
      })}
      editable={{
        onRowAdd: (newData) =>
          new Promise(async (resolve, reject) => {
            // setData([...data, newData]);
            const resp = await saveKpsCode({ ...newData, agreementId });
            if (resp && !resp.error) await setData((prev) => [...prev, resp]);
            resolve();
          }),
        onRowUpdate: (newData, oldData) =>
          new Promise(async (resolve, reject) => {
            const resp = await saveKpsCode({ ...newData, agreementId });
            if (resp && !resp.error) await setData((prev) => prev.map((v) => (v.id === resp.id ? resp : v)));
            resolve();
          }),
        onRowDelete: (oldData) =>
          new Promise(async (resolve, reject) => {
            const resp = await removeKpsCode({ id: oldData.id });
            if (resp) await setData((prev) => prev.filter((v) => v.id !== resp.id));
            resolve();
          }),
      }}
      icons={tableIconsModified}
      localization={localization}
      columns={columns}
      data={data}
    />
  );
}
